import logo from '../assets/images/logo.png';
import styled from 'styled-components';
import { up } from 'styled-breakpoints';

const LogoElem = styled.img`
  height: 40px;
  max-width: 100%;
  margin: 0 auto;
  margin-bottom: 1.5em;
  display: block;


  ${up('sm')} {
    max-width: 70%;
    margin-bottom: 2em;
  }

  ${up('md')} {
    margin-bottom: 2.5em;
  }

  ${up('lg')} {
    max-width: 50%;
    height: 45px;
    margin-bottom: 3em;
  }

  ${up('xl')} {
    margin-bottom: 3em;
    height: 50px;
  }

  ${up('xxl')} {
    height: 60px;
    margin-bottom: 4em;
  }

  ${up('giant')} {
    margin-bottom: 4.5em;
  }

`;

function Logo() {
    return (
        <LogoElem src={logo} alt='Eatsee Logo'></LogoElem>
    )
}

export default Logo;